import { render, staticRenderFns } from "./RefundRecordList.vue?vue&type=template&id=235cfaba&scoped=true"
import script from "./RefundRecordList.vue?vue&type=script&lang=js"
export * from "./RefundRecordList.vue?vue&type=script&lang=js"
import style0 from "./RefundRecordList.vue?vue&type=style&index=0&id=235cfaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235cfaba",
  null
  
)

export default component.exports